import React from "react";
import styles from "./Header.module.scss";
import MoneyItem from "./moneyItem/MoneyItem";
import usdIcon from "../../img/usd.png";
import eurIcon from "../../img/eu.png";
import { useAppSelector } from "../../store/store";
interface IProps {
  values?: [];
}

const Header: React.FC<IProps> = ({ values }) => {
  const { USD, EUR } = useAppSelector((state) => state.moneyValues.values);

  return (
    <header className={styles.header} id="header">
      <div className="container">
        <div className={styles.header__inner}>
          <a className={styles.header__logo} href="/">
            <svg
              width={45}
              height={45}
              version="1.1"
              id="Capa_1"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 360 360"
            >
              <g>
                <path
                  d="M359.724,287.393l-13.105-78.795c-0.466-2.792-1.989-5.236-4.289-6.879c-2.278-1.63-5.12-2.294-7.903-1.834l-14.561,2.422
		c1.151-7.339,1.753-14.817,1.752-22.387c0-38.208-14.878-74.13-41.897-101.146c-28.189-28.192-61.275-41.897-101.147-41.897
		c-1.131,0-2.259,0.02-3.386,0.046c-14.387-4.132-28.686-6.242-42.512-6.242c-48.646,0-82.028,25.445-99.173,42.859L16.76,61.573
		c-1.81-1.292-3.939-1.975-6.162-1.975c-1.983,0-3.922,0.554-5.606,1.604c-3.648,2.274-5.551,6.485-4.847,10.729L13.366,151.4
		c0.856,5.133,5.249,8.858,10.445,8.858c0.585,0,1.174-0.05,1.746-0.145l11.684-1.943c-1.08,7.134-1.643,14.397-1.643,21.752
		c0,38.25,14.854,74.171,41.831,101.147c27.018,27.017,62.939,41.896,101.146,41.896c1.811,0,3.613-0.046,5.412-0.112
		c14.66,4.288,29.235,6.465,43.323,6.466c48.642,0,82.027-25.446,99.171-42.861l16.741,11.967c1.76,1.258,3.823,1.939,5.983,1.975
		l0.032,0.002l0.462-0.004c5.706-0.157,10.301-4.848,10.301-10.591C360,288.989,359.907,288.179,359.724,287.393z M178.575,301.773
		c-32.547,0-63.148-12.674-86.162-35.689c-30.253-30.253-41.22-72.582-32.942-111.611l45.554-7.577
		c4.244-0.705,7.613-3.867,8.587-8.058c0.971-4.189-0.663-8.512-4.161-11.014l-19.801-14.155
		c8.196-18.001,25.773-43.447,61.389-52.486c8.927-2.054,18.149-3.114,27.536-3.114c32.549,0,63.15,12.675,86.165,35.69
		c30.423,30.422,41.341,73.055,32.8,112.262l-42.585,7.084c-4.242,0.707-7.609,3.869-8.583,8.061
		c-0.972,4.189,0.665,8.512,4.161,11.012l19.802,14.152c-6.1,13.4-17.393,30.925-37.456,42.74
		C216.217,297.379,197.734,301.773,178.575,301.773z"
                />
                <path
                  d="M184.849,169.457c-17.61-5.332-21.412-8.08-21.412-15.475c0-7.507,12.007-9.509,19.103-9.509
		c6.744,0,14.775,2.144,19.527,5.215c1.912,1.234,4.454,0.687,5.689-1.223l8.936-13.829c1.232-1.908,0.685-4.456-1.223-5.69
		c-6.607-4.269-15.279-7.306-24.248-8.548v-8.515c0-2.273-1.841-4.115-4.116-4.115h-16.462c-2.273,0-4.115,1.842-4.115,4.115v9.862
		c-17.23,4.551-27.786,16.666-27.786,32.236c0,27.314,23.439,34.413,38.948,39.109c16.688,5.053,20.051,7.34,19.998,13.628
		c0,6.952-11.473,8.807-18.251,8.807c-8.323,0-17.682-3.747-22.756-9.111c-0.752-0.792-1.785-1.256-2.877-1.285
		c-1.089-0.029-2.148,0.372-2.941,1.124l-11.961,11.314c-1.649,1.564-1.722,4.168-0.16,5.819
		c6.966,7.361,16.949,12.844,27.786,15.334v9.394c0,2.272,1.842,4.115,4.115,4.115h16.462c2.275,0,4.116-1.843,4.116-4.115v-8.946
		c19.057-3.561,31.163-15.98,31.159-32.346C222.6,180.891,199.883,174.01,184.849,169.457z"
                />
              </g>
              <g></g>
              <g></g>
              <g></g>
              <g></g>
              <g></g>
              <g></g>
              <g></g>
              <g></g>
              <g></g>
              <g></g>
              <g></g>
              <g></g>
              <g></g>
              <g></g>
              <g></g>
            </svg>

            <span className={styles.header__logoName}>Money-converter</span>
          </a>

          <nav className={styles.nav}>
            <MoneyItem
              icon={usdIcon}
              description="USD"
              values={USD.toFixed(2)}
            />
            <MoneyItem
              icon={eurIcon}
              description="EUR"
              values={EUR.toFixed(2)}
            />
          </nav>
        </div>
      </div>
    </header>
  );
};

export default Header;
